import { NavLink } from "react-router-dom";

import OutputCombo from "components/OutputCombo";
import CompareGraph from "components/Graph/CompareGraph";
import TotalEarnings from "components/TotalEarnings";

import GreenBars from "components/svg/GreenBars";

export default function EarningsVsCost({ miningData, electricityData, gasData, showBars }: any) {

  const { eurosMined = 0, bitcoinMined = 0, exchangeRate = 0 } = miningData?.total ?? {};
  const { eurosImportedFromGrid = 0 } = electricityData?.total ?? {};
  const { eurosGasConsumed = 0 } = gasData?.total ?? {};

  return (
    <div className="output-card">
      {showBars ? (
        <NavLink className="absolute top-6 right-3" to={`${process.env.PUBLIC_URL}/bitcoin-earnings`}>
          <GreenBars />
        </NavLink>
      ) : null}
      <div className="flex-shrink-0 mb-3 pt-7 px-7 text-gray-500 font-bold">Earnings Vs Cost</div>
      <div className="flex flex-col justify-between px-7">
        <OutputCombo
          title="Bitcoin Earnings (€ Gross)"
          info="Some Info about"
          bigValue={`${eurosMined.toLocaleString("en-GB", { style: "currency", currency: "EUR" })}`}
          smallValue={`${bitcoinMined.toFixed(4)} BTC`}
          className="mb-2"
          hasDivide
        />
        <OutputCombo
          title="Energy Cost"
          info="Some Info about"
          bigValue={`${(eurosImportedFromGrid + eurosGasConsumed).toLocaleString("en-GB", { style: "currency", currency: "EUR" })}`}
          smallValue={`${(exchangeRate ? (eurosImportedFromGrid + eurosGasConsumed) / exchangeRate : 0).toFixed(4)} BTC`}
          className="mt-3"
          hasDivide
        />
        <CompareGraph
          className="max-h-48 w-full sm:w-auto"
          title="Earnings Vs Cost"
          firstData={miningData ? { title: "BTC Earnings", ...miningData } : null}
          secondData={electricityData ? { title: "Energy cost", ...electricityData } : null}
        />
      </div>
      <TotalEarnings miningTotal={miningData ? miningData.total : null} electricityTotal={electricityData ? electricityData.total : null} />
    </div>
  );
}
